export default {
    tabbar: {
        home: `Page d'accueil`,
        trading: 'Commerce',
        invest: 'Investissements',
        share: 'Partager',
        mine: 'La mienne.'
    },
    common: {
        deposit: 'Dépôts',
        withdrawal: 'Retrait',
        share: 'Partager',
        team: 'Équipe',
        task: 'Mission',
        addr: 'Adresse',
        logout: 'Passation par profits et pertes',
        wallet: 'Portefeuille',
        account: 'Comptes',
        promotion: 'Promotion',
        details: 'Détails',
        dailyRevenue: 'Gains journaliers',
        dailyRevenueList: 'Liste quotidienne des prestations',
        aboutUs: 'À propos de nous',
        globalPartners: 'Partenaires mondiaux',
        totalBalance: 'Solde total',
        profitList: 'Liste des revenus financiers',
        notification: 'Notification',
        previous: 'Article précédent',
        close: 'Fermer',
        next: 'Article suivant',
        investWallet: "Portefeuille d'investissement",
        financialWallet: 'Portefeuille financier',
        recharge: 'Recharge',
        copySucceeded: 'Copie réussie',
        copyFailed: 'La réplication a échoué',
        promotionWallet: 'Portefeuille promotionnel',
        registerRewardWallet: 'Portefeuille de récompenses enregistré',
        toAddress: 'Adresse du portefeuille TRON pour la collecte (début t)',
        verifyYourPassword: 'Vérifiez votre mot de passe',
        serviceFee: 'Gas fees',
        confirm: 'Confirmation',
        submitted: 'Soumis',
        date: 'Date',
        amount: 'Montant',
        accountAvailableBalance: 'Solde disponible du compte',
        securityPassword: 'Mot de passe sécurisé',
        withdrawalPrincipal: 'Retrait du principal',
        withdrawalProfit: 'Retrait des bénéfices',
        profitRate: 'Taux d\'intérêt',
        notificationAndFAQ: 'FAQ et avis',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Caractéristiques/introduction du projet',
                content: `R:
1. En tant que premier code d’investissement audité éprouvé du secteur, notre solution vise à prouver que les contrats intelligents sont l’avenir de l’investissement. Sa longévité et sa stabilité finiront par perturber l’industrie de la cryptographie et la façon dont les gens envisagent l’investissement et le trading. L'industrie conventionnelle des jetons est confrontée à de nombreux défis, notamment les escroqueries aux jetons, les tapis, la volatilité du marché, les développeurs malhonnêtes qui volent les fonds des utilisateurs et le manque de liquidité.

2. Le code de fiabilité dont nous disposons est basé sur la structure de la solution et notre solution ne sera en aucun cas affectée par ces défis et bien d’autres qui surviennent dans l’industrie de la cryptographie. Notre plateforme ne nécessite pas de liquidité de marché. Par conséquent, votre investissement et vos revenus attendus sont en sécurité car nous ne dépendons pas des changements dans l’industrie. Au lieu de cela, nous avons construit une solution basée sur un nouvel attrait pour les utilisateurs mais fonctionnant sur des contrats intelligents ! Notre code et notre structure sont sécurisés, avec une longévité et une transparence garanties. Par conséquent, nous disposons d’un programme de parrainage très attractif et robuste avec des statistiques détaillées et transparentes pour chaque promoteur/utilisateur. Les revenus de l’initiateur, ainsi que ceux des autres utilisateurs, sont instantanément ajoutés au profil et contrairement aux autres solutions d’investissement DeFi, les gens peuvent retirer instantanément des fonds à tout moment.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:Quel est notre avantage ?',
                content: `R:Nos systèmes sont audités par l'équipe de sécurité Haze et disposent d'auditeurs Smart Contract indépendants
1. Sûr et fiable : pas besoin de transférer de devises, l'USDT est déposé dans votre propre portefeuille sans risque
2. Stabilité professionnelle : équipe professionnelle, fonctionnement stable tout au long de l'année
3. Seuil d'entrée bas : partager les revenus miniers des nœuds
4.Pool minier USD ETHW AI Strategy-C : pas besoin de transférer de devises, revenu stable
5. Nous nous engageons à créer la plus grande plateforme DeFi intégrée au monde DEX, IMO et DAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Comment puis-je m\'impliquer ?',
                content: `R:
1. Le portefeuille est sur la chaîne et la station portefeuille est équipée d'un navigateur Dapp.
2. Connectez TRC20 à USDT et déposez-le dans votre portefeuille
3. Entrez Gongwang via le navigateur de portefeuille
4. Votre portefeuille doit avoir plus de 30 trx en frais de minage pour participer à ce projet
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Combien de temps faut-il pour participer au minage ?',
                content: `R:Le temps ne peut pas être calculé. Normalement, cela peut être terminé dans les 4 heures. Si d'autres raisons incertaines sont rencontrées, le délai peut être prolongé.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Pourquoi devons-nous payer des frais miniers pour encaisser les bénéfices ?',
                content: `R:Car dans ce processus de participation au minage, les clients ne sont comptés que nominativement, et les frais de minage générés ont été payés par les mineurs. Les revenus générés sont en fait dans le pool contractuel, et ce n'est qu'en payant des frais miniers que vous pouvez échanger contre des revenus.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Comment retirer les bénéfices ?',
                content: `R:Après avoir obtenu l'USDT, vous devez avoir une petite quantité de TRX dans votre portefeuille pour les frais de transaction. Vous ne devez payer qu'une seule fois et l'échange USDT sera effectué dans un délai d'un jour ouvrable légal. Lorsque vous effectuez un retrait, le retrait USDT sera automatiquement envoyé à l'adresse du portefeuille du nœud que vous avez rejoint. Les autres adresses ne sont pas prises en charge.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Qu’est-ce que l’extraction de liquidité Defi ?',
                content: `R:Le minage de liquidités est un type de finance décentralisée DeFi. Il n'a pas besoin d'acheter des cartes graphiques, de contribuer à la puissance de calcul ou de payer des factures d'électricité coûteuses, mais gagne des revenus en fournissant des fonds et des liquidités. Surtout récemment, les prix des devises ont considérablement fluctué. Pour certains détenteurs de pièces engagés, l’extraction de liquidités est un moyen de gagner des revenus et d’accumuler plus de cryptomonnaies sans avoir besoin de transactions.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:Comment ça marche?',
                content: `R:Notre solution est un accord de transaction informatisé qui applique automatiquement les termes d'un contrat entre deux parties. À l’instar des contrats universels, les deux utilisateurs de notre plateforme doivent définir les règles et conditions de participation lors du trading. Une fois qu’un accord est conclu et qu’un contrat intelligent est lancé, il fonctionne comme prévu, sans aucune chance de modification des conditions prédéterminées. Lorsqu'un utilisateur lance une activité dans le pool de minage d'un nœud blockchain, il doit y avoir un solde disponible sur le contrat. Le reste des utilisateurs s'en remet au contrat pour l'exécuter, n'ayant plus à attendre de longues heures pour vérifier quand vendre ou acheter. Ainsi, selon les termes du contrat, la valeur de votre investissement est garantie de ne jamais diminuer ; au contraire, cela rapporte 100 % de profit à nos utilisateurs.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'Le montant du retrait doit être supérieur au montant du gaz consommé',
        supportTips: 'Cher utilisateur : Nous avons mis en place pour vous un service exclusif d\'assistance au pool minier. Vous pouvez nous écrire pour des conseils, des réclamations, des suggestions, etc., et nous vous répondrons et le traiterons dans les 24 heures !',
        tips: 'Astuces',
        Withdrawals_prohibited: 'Les conditions de retrait ne sont pas remplies actuellement, veuillez d\'abord terminer la tâche.'
    },
    homePage: {
        theCommonProblem: 'Questions fréquemment posées',
        latestAnnouncement: 'Dernières annonces',
        block5title: 'Rejoignez Tron Millionaire',
        block5desc: "Utilisez les technologies d'extraction en nuage et defi pour vous assurer que tous les utilisateurs reçoivent les revenus USDT les plus élevés.",
        block6title: 'Présentation des données de la plateforme',
        accumulatedProfit: 'Recettes cumulées',
        membership: 'Membres',
        block7title: 'Nous sommes en pleine forme',
        block7desc: "hako est une société enregistrée à Singapour, numéro de licence : PS20200556. Nous sommes le seul site Web d'investissement de contrats intelligents audité et vérifié dans l'espace des crypto-monnaies opérant sur le réseau TRON Smart Chain (TRON). hako cloud mining offre un pipeline de minage potentiellement rentable pour Bitcoin USDT et d'autres crypto-monnaies. Dans le même temps, le trading quantitatif et la technologie DeFi vous permettront de participer facilement à des transactions blockchain avec un petit capital et d'obtenir des revenus stables comme une assurance.",
        tzl: 'investi',
        zl: 'Gagné'
    },
    investPage: {
        productList: 'Liste des produits',
        investedList: 'Liste des investissements',
        dailyRate: "Taux d'intérêt journalier",
        cycle: 'Cycle',
        day: 'jour',
        productDetails: 'Détails du produit'
    },
    tradingPage: {
        miningWorking: "L'exploitation des nuages fonctionne",
        tradingProfit: 'Produits de la transaction',
        settlementRule: 'Règlement 24 heures sur 24',
        viewAll: 'Voir tout',
        quantifyingTransactionRevenue: 'Revenu de trading qualitatif',
        receive: 'Recevoir',
        received: 'Reçu',
        rule: 'Règles minières',
        rules: 'Si vous souhaitez que "Cloud Mining" commence à fonctionner et vous rapporte un revenu quotidien, veuillez l\'activer dans "Financial Wallet". Lorsque le solde USDT de votre portefeuille remplit certaines conditions, vous recevrez un revenu quotidien et les revenus générés seront conservés pendant 30 jours. Veuillez cliquer pour le réclamer à temps. Calculez votre pourcentage de revenus quotidiens en fonction du tableau ci-dessous :',
        profit: 'Profit',
        miningNotWorking: 'Le cloud mining ne fonctionne pas, veuillez l\'activer',
        balance: 'équilibre'
    },
    sharePage: {
        text1: 'Invitez vos contacts',
        text2: 'Ou amis et récompenses',
        text3: 'Recommander et recevoir des récompenses',
        text4: "Partagez vos liens recommandés et commencez à gagner de l'argent",
        copyLink: 'Copier la connexion'
    },
    minePage: {
        trxDepositInvestment: 'USDT Investment Deposit',
        trxDepositFinancial: 'USDT Financial Deposit',
        tips: "Déposer n'importe quel nombre de USDT pour activer le compte et activer la fonction de retrait",
        appServices: "Services d'application"
    },
    depositPage: {
        text1: "L'investissement est divisé en deux modes",
        text2: "1:Rechargez dans votre portefeuille d'investissement et vous pouvez obtenir des rendements à différents cycles, en remboursant le principal et les rendements à l'échéance",
        text3: "2 : Activez la fonction \"cloud mining\" dans votre portefeuille financier et recevez chaque jour des revenus selon le fuseau horaire de Singapour (après 12h).",
        text4: 'Notes:',
        text5: "Avant d'investir, sélectionnez un compte d'investissement ou un compte de gestion financière en fonction de vos besoins d'investissement. Assurez - vous d'attendre que le compte soit rechargé. C'est une question cruciale."
    },
    rechargePage: {
        trxAddress: 'Adresse TRC20-USDT',
        copyAddress: "Copier l'adresse",
        tips1: "Veuillez ne pas recharger d'autres actifs non USDT. Enregistrer environ 5 à 10 minutes après le remplissage.",
        tips2: "Rafraîchissez cette page si elle n'est pas livrée depuis longtemps. Investissement minimum 5 USDT.",
        rechargeCompleted: 'Recharge terminée',
        inactivated: 'Inactivée',
        activated: 'Activé',
        tips3: 'Pas besoin de cliquer à plusieurs reprises. Le cloud mining commence à fonctionner environ 5 à 10 minutes après l\'envoi de la demande.',
        tips4: 'S\'il n\'a pas été activé depuis longtemps, veuillez cliquer à nouveau sur le bouton d\'activation.',
        ActivateCloudMining: 'Activer le cloud mining'
    },
    withdrawalPage: {
        text1: 'Solde du compte de base (USDT)',
        text2: 'Le retrait sera reçu dans les 24 heures',
        dailyWithdrawalLimit: 'Limite quotidienne de retrait',
        unlimit: 'Illimité'
    },
    teamPage: {
        intro: 'Les utilisateurs que vous invitez directement et indirectement peuvent gagner des dividendes pour vous. Supposons que vous invitiez l\'utilisateur A, les revenus financiers gagnés par l\'utilisateur A seront envoyés dans votre portefeuille sous forme de récompense en pourcentage. Si l\'utilisateur A invite l\'utilisateur B et que B invite à son tour C, vous pouvez obtenir A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%) de récompense en pourcentage du revenu de l\'utilisateur !',
        level: 'Hiérarchie',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Nombre',
        rewards: 'Récompenses'
    },
    productDetailsPage: {
        startingAmount: 'Montant initial',
        maxInvestmentAmount: 'Investissement maximal',
        dailyInterestRate: "Taux d'intérêt journalier",
        investableQuantity: 'Montant investi',
        investmentAmount: 'Montant des investissements',
        participateInInvestment: 'Participation aux investissements'
    },
    investedListPage: {
        investmentTime: "Temps d'investissement",
        settlementTime: 'Temps de règlement',
        settlementAmount: 'Montant du Règlement'
    },
    loginPage: {
        MobileNumber: 'Numéro de téléphone portable',
        LoginPassword: 'Mot de passe de connexion',
        SignIn: 'Connexion',
        SignUp: 'Inscription',
        rememberThePassword: ' Rappelez - vous le mot de passe.',
        inviteCode: "Code d'invitation",
        captcha: 'Code de vérification',
        EncryptedRegistration: 'Enregistrement chiffré',
        desc: "Les mots de passe sont stockés dans des pipelines dispersés et ne peuvent pas être récupérés s s'ils sont perdus. Rappelez - vous votre mot de passe.",
        registerSuccess: 'Compte créé avec succès'
    },
    taskPage: {
        desc: `Chaque montant de recharge valide que vous invitez un membre subalterne inscrit sera converti en votre montant de retrait (compte de primes promotionnelles) proportionnellement.`,
        rwconvertRate: 'Échelle de conversion',
        totalLimit: 'Montant cumulé',
        availableLimit: 'Montant disponible',
        contactService: 'Contactez le service à la clientèle'
    },
    Please_unlock_your_wallet: 'Veuillez déverrouiller votre portefeuille',
    Please_open_the_website_in_the_Dapp_browser: 'Veuillez ouvrir le site Web dans le navigateur Dapp'
}
